
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skillbuilders/fleischerscholars",
      function () {
        return require("private-next-pages/skillbuilders/fleischerscholars.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skillbuilders/fleischerscholars"])
      });
    }
  